<template>
    
  <div>

    <v-card tile outlined>

      <v-container>
          
        <h3>Datos del alumno</h3>
        
          <v-row>
            
            <v-col cols="12">
              <v-radio-group v-model="alumnoType" row :mandatory="false" @change="changeOpcion">
                <v-radio label="Nuevo alumno/a" value="nuevo"></v-radio>
                <v-radio label="Antiguo alumno/a de Fundación Idiomas" value="antiguo"></v-radio>
              </v-radio-group>
            </v-col>

          </v-row>
              
          <template v-if="alumnoType == 'antiguo'">
            <v-card-text>
            
              <v-row>
                    
                <v-col cols="4">

                  <v-text-field 
                    v-model="codigo" 
                    label="Nº Alumno"
                    :error-messages="showErrorCodigo ? ['No coincide con ningún alumno/a'] : []"
                  >
                    <v-btn
                      slot="append"
                      color="primary" 
                      :loading="loadingCodigo"
                      text
                      :disabled="!codigo"
                      @click="comprobarCodigo"
                    >
                      Comprobar
                    </v-btn>

                  </v-text-field>
                
                </v-col>

              </v-row>
            
            </v-card-text>

          </template>             
          
          <template v-if="alumnoType == 'nuevo'">
            <v-form v-model="formNuevoAlumnoValid" @submit.prevent="onSubmit($event)">
              
              <v-card-text>

                <alumno-datos-form-fields
                  :alumno="nuevoAlumno"
                  :nombreRules="nombreRules"
                  :dateRules="dateRules"
                  :key="alumnoDatosFormFieldsKey"
                ></alumno-datos-form-fields>


                <small>*Indica campo requerido</small>
              
              </v-card-text>
        
              <v-card-actions>
                <v-btn 
                  type="submit" 
                  color="primary" 
                  :loading="loading"
                  text
                  :disabled="!formNuevoAlumnoValid">
                  Guardar
                </v-btn>
              </v-card-actions>    

            </v-form>
          
          </template>

          <template v-if="alumno != null">
          
            <v-divider class="mb-6"></v-divider>

            <h3>Idiomas</h3>

            <alumno-idiomas-form
              :idiomas="idiomas"
              :niveles="niveles"
              :alumno="alumno"
              :idiomasAlumno="idiomasAlumno"
              :loadingGuardar="loadingIdiomas"
              :allowSaveEmpty="false"
              @submit="onSubmitIdiomas"
              @delete="onDeleteIdioma"
            ></alumno-idiomas-form>
          
          </template>

      </v-container>

    </v-card>

    <!-- popup de confirmación -->
    <confirm ref="confirm"></confirm>

  </div>

</template>


<script>

import { checkPersonaReferencia, postPersona, putPersona } from '@/api/personas.api'
import AlumnoDatosFormFields from '@/components/prematricula/AlumnoDatosFormFields'
import AlumnoIdiomasForm from '@/components/prematricula/AlumnoIdiomasForm'
import _ from 'lodash'
import { update } from '@/api/prematriculas.api'
import Confirm from '@/components/Confirm'
import DateUtils from '@/libraries/DateUtils'

export default {
  name: 'AlumnoNuevoForm',
  components: {
    AlumnoDatosFormFields,
    AlumnoIdiomasForm,
    Confirm
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
    prematriculaAlumnosIdiomas: {
      type: Array,
      required: true
    },
    idiomas: {
      type: Array,
      required: true
    },
    niveles: {
      type: Array,
      required: true
    }
  },

  data: () => {
    return {
      
      // datos 
      alumno: null,
      idiomasAlumno: [],
      
      // tipo de alumno por defecto para los radio buttons
      alumnoType: 'nuevo',

      // codigo alumno
      codigo: '',
      showErrorCodigo: false,
      loadingCodigo: false,

      // formulario datos alumno
      formNuevoAlumnoValid: false,
      loading: false,
      nuevoAlumno: {
        nombre: null,
        dni: null,
        fechaNacimiento: null,
        telefono: null
      },
      alumnoDatosFormFieldsKey: 0,

      // reglas para el formulario
      nombreRules: [
        v => !!v || 'El campo es obligatorio',
      ],
      dateRules: [
        v => !!v || 'El campo es obligatorio',
      ],

      // formulario de idiomas
      loadingIdiomas: false,

    }
  },

  created() {
    this.initFechaNacimiento()
  },

  methods: {

    initFechaNacimiento() {
      let dateUtils = new DateUtils()
      this.nuevoAlumno.fechaNacimiento = dateUtils.formatDateYYYYMMDD()
    },

    changeOpcion(value) {

      this.resetData()

      if (value == 'nuevo') {
        // reset nro de alumno
        this.resetCodigo()
      } else {
        // reset formulario nuevo alumno
        this.resetNuevoAlumno()
      }

    },

    resetData() {
      this.alumno = null
      this.idiomasAlumno = []
    },

    resetNuevoAlumno() {
      this.nuevoAlumno.nombre = null
      this.nuevoAlumno.dni = null
      this.nuevoAlumno.telefono = null
      this.initFechaNacimiento()
    },

    resetCodigo() {
      this.codigo = ''
      this.showErrorCodigo = false
    },

    resetAllData() {
      this.resetData()
      this.resetNuevoAlumno()
      this.resetCodigo()
      this.alumnoType = 'nuevo'
      this.forceRerenderAlumnosDatos() // cambia el key del componente para obligar a renderizarlo de nuevo
    },

    async comprobarCodigo() {
      
      try {
        
        this.loadingCodigo = true

        const response = await checkPersonaReferencia(this.codigo)
        this.alumno = response.data
        this.idiomasAlumno = []
        this.showErrorCodigo = false

      } catch( error ) {
        this.alumno = null
        this.idiomasAlumno = []
        this.showErrorCodigo = true
      }
      
      this.loadingCodigo = false
            
    },

    async onSubmit() {
      
      this.loading = true;
      
      // validacion y emit
      if (this.formNuevoAlumnoValid) {

        // valores del formulario
        const params = {
          ...this.nuevoAlumno
        }

        /**
         * si no tenemos alumno se crea
         * de lo contrario se actualiza
         */
        if (this.alumno == null) {

          // crear alumno
          await postPersona(params).then(response => {
            this.alumno = response.data
          }).catch(error => {
            console.error(error)
          })

        } else {
          
          // editar alumno
          await putPersona(this.alumno.id, params).then(response => {
            this.alumno = response.data
          }).catch(error => {
            console.error(error)
          })

        }
        
      }
      
      this.loading = false;
    },


    /**
     * Envio del formulario de idiomas, tener en cuenta que la llamada a la 
     * api tiene que enviar los del usuario actual + los de los otros alumnos de la prematricula
     */
    async onSubmitIdiomas() {
      
      this.loadingIdiomas = true

      
      // unir array de idiomasAlumno a los de la prematricula para la query
      let alumnos = this.unirIdiomasPrematricula(this.idiomasAlumno)

      // Pasar idiomas o niveles como objetos vacios a nulos. Evitar 500 en el api.
      alumnos.map((prematriculaAlumno) => {
        if ( prematriculaAlumno.idioma != null && _.isEmpty(prematriculaAlumno.idioma) ) {
          prematriculaAlumno.idioma = null
        }
        
        if ( typeof prematriculaAlumno.nivel === 'undefined' || (prematriculaAlumno.nivel != null && _.isEmpty(prematriculaAlumno.nivel)) ) {
          prematriculaAlumno.nivel = null
        }
        return prematriculaAlumno
      })

      let params = {
        alumnos: alumnos
      }

      // actualizar alumnos/idiomas
      await update(this.item , params).then(response => {
        this.$emit('submitAlumnoNuevo', event, response)
        this.resetAllData()
      }).catch(error => {
        console.error(error)
      })
      
      this.loadingIdiomas = false
      
    },

    async onDeleteIdioma(event, index) {
      
      let title = 'Borrar idioma'
      let subtitle = '¿Estás seguro?'
      let message = 'El idioma se eliminará del listado de idiomas de forma permanente.'
      let message2 = null 

      // confirmacion
      if (await this.$refs.confirm.open(
        title,
        subtitle, 
        message,
        message2,
        { 
          color: 'primary',
          width: 300 
        })
      ) {
        // Si acepta borramos el item del array de idiomas del alumno
        this.idiomasAlumno.splice(index, 1)
      }

    },

    unirIdiomasPrematricula(idiomasAlumno) {
      const allIdiomas = [...this.prematriculaAlumnosIdiomas, ...idiomasAlumno]
      return _.uniqWith(allIdiomas, _.isEqual);
    },

    forceRerenderAlumnosDatos() {
      this.alumnoDatosFormFieldsKey += 1
    }

  }

}

</script>